module.exports = __webpack_public_path__ + "7df5effeaed628077e2367b9f648b284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile5.png
// module id = 1888
// module chunks = 0